export const buildUpdateOneProduct = (state, action) =>
  state.map((item) => {
    if (item.id === action.product.id) {
      return action.product;
    }
    return item;
  });
